module.exports = __webpack_public_path__ + "img/banner-1.190a68fa.jpg";